import { ERC20Token } from '@pancakeswap/sdk'
import { ChainId } from '@pancakeswap/chains'

export const WALLCHAIN_ENABLED = true

export const WallchainKeys = {
}

export const WallchainPairs = [
]
